import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import classNames from "classnames";
import {
  Grid,
  FormControl,
  InputLabel,
} from "@material-ui/core";
import Button from "components/CustomButtons/Button.jsx";
import InlineDatePicker from "../../utils/InlineDatePicker"
import { appConstants } from "../../_constants";
import AutocompleteSelect from "../../utils/AutocompleteSelect";

const styles = theme => ({
  container: {
    display: "flex",
    flexWrap: "wrap"
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200
  },
  root: {
    flexGrow: 1,
    paddingLeft: '15px'
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: "center",
    color: theme.palette.text.secondary
  },
  formRoot: {
    display: "flex",
    flexWrap: "wrap"
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 100
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 1
  },
  searchButton: {
    backgroundColor: " #66bb6a"
  },
  airlineSelect: { marginTop: "0px", width: '100%' },
  Grid: {
    flexBasis: "14px"
  }
});

function SearchComponent(props) {
  // let { classes, airlines, selectChange, AirlineId, FlightNumber, StartDate, EndDate, flightNumbers } = props;
  let {
    classes, StartDate, EndDate, airlines, selectChange, flightNumbers, onSearch, handleDateChange,
    user, allLocations, AirportCode, AirlineId
  } = props;

  return (
    <div className={classes.root}>
      <Grid container spacing={24}>
        <Grid item md={2}>
          <FormControl
            className={classNames(classes.airlineSelect, classes.formControl)}
          >
            <InputLabel shrink htmlFor="age-label-placeholder">
              Airlines
            </InputLabel>
            <AutocompleteSelect
              options={airlines.map(option => ({ value: option.AirlineId, label: option.Airline }))}
              selectedOption={AirlineId}
              handleSelectChange={(e, name) => selectChange(e, name)}
              selectLabel={"Airlines"}
              disabled={user.AppRole === appConstants.ROLES.AIRLINE}
              name={"AirlineId"}
            />
            {/* <Select
              value={AirlineId}
              disabled={user.AppRole === appConstants.ROLES.AIRLINE}
              onChange={selectChange}
              input={<Input name="airline" id="airline-label-placeholder" />}
              // displayEmpty
              name="AirlineId"
              className={classes.selectEmpty}
            >
              <MenuItem value="-1">All Airlines</MenuItem>
              {airlines.map((option, i) => (
                <MenuItem
                  key={i}
                  value={option.AirlineId}
                  className={classes.select}
                >
                  {option.Airline}
                </MenuItem>
              ))}
            </Select> */}
          </FormControl>
        </Grid>
        <Grid item md={2}>
          <FormControl
            className={classNames(classes.airlineSelect, classes.formControl)}
          >
            <InputLabel shrink htmlFor="age-label-placeholder">
             All Flights
             </InputLabel>
            <AutocompleteSelect
                options={flightNumbers.map(option => ({value: option.FlightNumber, label: option.FlightNumber}))}
                 name={"FlightNumber"}
                handleSelectChange={(e, name) => selectChange(e, name)}

            />
            {/* <Select
              value={FlightNumber}
              onChange={selectChange}
              input={<Input name="Flight No" id="airline-label-placeholder" />}
              name="FlightNumber"
              className={classes.flightNumber}
            >
              <MenuItem value="-1"> All Flights</MenuItem>
              {flightNumbers.map((option, i) => (
                <MenuItem
                  key={i}
                  value={option.FlightNumber}
                  className={classes.flightNumber}
                >
                  {option.FlightNumber}
                </MenuItem>
              ))}
            </Select>
            */
           }
          </FormControl>
        </Grid>
        {/*<Grid item md={2}>*/}
        {/*<FormControl*/}
        {/*className={classNames(classes.airlineSelect, classes.formControl)}*/}
        {/*>*/}
        {/*<InputLabel shrink htmlFor="age-label-placeholder">*/}
        {/*Locations*/}
        {/*</InputLabel>*/}
        {/*<Select*/}
        {/*value={departureLocations}*/}
        {/*onChange={selectChange}*/}
        {/*input={<Input name="departureLocations" id="departureLocations-label-placeholder" />}*/}
        {/*// displayEmpty*/}
        {/*name="departureLocations"*/}
        {/*className={classes.select}*/}
        {/*>*/}
        {/*<MenuItem value="-1"> All Locations</MenuItem>*/}
        {/*{allLocations.map((option, i) => (*/}
        {/*<MenuItem*/}
        {/*key={i}*/}
        {/*value={option.Code}*/}
        {/*className={classes.select}*/}
        {/*>*/}
        {/*{option.Name}*/}
        {/*</MenuItem>*/}
        {/*))}*/}
        {/*</Select>*/}
        {/*</FormControl>*/}
        {/*</Grid>*/}
        <Grid item md={3}>
          <div>
            <InlineDatePicker label={'Start Date'} Date={StartDate} handleDateChange={(date) => handleDateChange(date, 'StartDate')} />
          </div>
        </Grid>
        <Grid item md={3}>
          <div>
            <InlineDatePicker label={'End Date'} Date={EndDate} handleDateChange={(date) => handleDateChange(date, 'EndDate')} />
          </div>
        </Grid>
        <Grid item md={2}>
          <FormControl
            className={classNames(classes.airlineSelect, classes.formControl)}
          >
            <InputLabel shrink htmlFor="age-label-placeholder">
              Airports
            </InputLabel>
            <AutocompleteSelect
                options={allLocations.map(option => ({value: option.Code, label: option.Name}))}
                name={"AirportCode"}
                handleSelectChange={(e, name) => selectChange(e, name)}
                disabled={user.AppRole === appConstants.ROLES.AIRPORT_MANAGER || (user.Location)}
                selectedOption={AirportCode}
            />
            {/*
            <Select
              value={AirportCode}
              disabled={user.AppRole === appConstants.ROLES.AIRPORT_MANAGER || (user.Location)}
              onChange={selectChange}
              input={<Input name="departureLocations" id="departureLocations-label-placeholder" />}
              // displayEmpty
              name="AirportCode"
              className={classes.select}
            >
              <MenuItem value="-1"> All Airports</MenuItem>
              {allLocations.map((option, i) => (
                <MenuItem
                  key={i}
                  value={option.Code}
                  className={classes.select}
                >
                  {option.Name}
                </MenuItem>
              ))}
            </Select> */}
          </FormControl>
        </Grid>
        <Grid item >
          <Button color={'primary'} onClick={() => onSearch()}>Search</Button>
        </Grid>
      </Grid>
    </div>
  );
}

SearchComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  selectChange: PropTypes.func.isRequired
};

export default withStyles(styles)(SearchComponent);



// WEBPACK FOOTER //
// ./src/views/AirlinesPassenger/SearchPanel.jsx